/* eslint-disable react/prop-types */
import { Box } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';
import Tag from 'views/ProductManagement/components/Tag';
import classes from './TagCell.module.scss';

const TagCell = ({ tags, className }) => {
  return (
    <Box className={clsx(classes.tagCell, className)} display='flex' flexWrap='wrap' gridGap={8}>
      {(tags || []).map(({ id, name, isRed, tooltip }, index) => {
        return (
          <Tag
            key={id || index}
            label={name}
            className={clsx(classes.tagItem, {
              [classes.isRed]: isRed,
            })}
            tooltip={tooltip}
          />
        );
      })}
    </Box>
  );
};

export default TagCell;
